export enum CustomerForm {
	DepositForm = 'DepositForm',
	LoanForm = 'LoanForm',
	TestForm = 'TestForm',
	ContactForm = 'ContactForm',
}
